import React from 'react';

export default ({ name, children, value, className }) => {
  return (
    <div className={className ? `row ${className}` : 'row'}>
      <div className='name'>{name}</div>
      <div className='value'>{children ? children : value}</div>
    </div>
  );
};
